import React from 'react';
import { motion } from 'framer-motion';

const Stats = () => {
    const stats = [
        { label: 'OFFICES', value: '2' },
        { label: 'HAPPY CLIENTS', value: '12' },
        { label: 'PROJECTS DONE', value: '25' },
        { label: 'YEARS EXPERIENCE', value: '1' },
    ];

    return (
        <section className="bg-white text-slate-900 py-8 relative font-sans border-t border-slate-200 shadow-sm z-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-0 md:divide-x divide-slate-200">
                    {stats.map((stat, index) => (
                        <div
                            key={index}
                            className={`flex flex-col items-center justify-center py-2 px-4 text-center group cursor-default ${index % 2 !== 0 ? 'border-l border-slate-200 md:border-l-0' : ''}`}
                        >
                            <motion.div
                                initial={{ opacity: 0, scale: 0.5 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                viewport={{ once: true }}
                                className="text-4xl md:text-5xl font-extrabold mb-1"
                            >
                                <span className="text-slate-900">{stat.value}</span><span className="text-blue-600">+</span>
                            </motion.div>
                            <div className="text-[10px] md:text-xs font-bold tracking-[0.15em] text-slate-500 uppercase group-hover:text-blue-600 transition-colors">
                                {stat.label}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Stats;
